import { BillingInfo, IBillingInfo } from "./billingInfo";
import { IOrderProductItem, OrderProductItem } from "./orderProductItem";
import { IOrderShipping, OrderShipping } from "./orderShipping";
import { IPayment, Payment } from "./payment";

export interface IOrderHistory {
    orderId?: string;
    ownerId?: string;
    basketId?: string;
    branchId?: string;
    couponCodeList: string[];
    voucherId: string[];
    specialComment: string;
    requestSubstitute: boolean;
    noPlasticBag: boolean;
    productList: IOrderProductItem[];
    shipping?: IOrderShipping;
    subTotal?: number;
    grandTotal?: number;
    bogoDiscount?: number;
    cartDiscount?: number;
    billingInfo?: IBillingInfo;
    deliveryFee?: number;
    payment?: Payment;
}

export class OrderHistory implements IOrderHistory {
    orderId?: string | undefined;
    ownerId?: string | undefined;
    basketId?: string | undefined;
    branchId?: string | undefined;
    couponCodeList: string[] = [];
    voucherId: string[] = [];
    specialComment = "";
    requestSubstitute = false;
    noPlasticBag = false;
    productList: IOrderProductItem[] = [];
    shipping?: IOrderShipping | undefined;
    subTotal?: number | undefined;
    grandTotal?: number | undefined;
    bogoDiscount?: number | undefined;
    cartDiscount?: number | undefined;
    billingInfo?: IBillingInfo;
    deliveryFee?: number;
    payment?: IPayment;


    constructor(data: IOrderHistory) {
        if (data) {
            this.orderId = data.orderId
            this.ownerId = data.ownerId
            this.basketId = data.basketId
            this.branchId = data.branchId
            if (data.couponCodeList) {
                this.couponCodeList = data.couponCodeList.map((x) => x)
            }
            this.voucherId = data.voucherId.map((x) => x)
            this.specialComment = data.specialComment ? data.specialComment : ''
            this.requestSubstitute = data.requestSubstitute ? data.requestSubstitute : false
            this.noPlasticBag = data.noPlasticBag
            if (data.productList) {
                this.productList = data.productList.map((x) => new OrderProductItem(x))
            }
            if (data.shipping) { this.shipping = new OrderShipping(data.shipping) }
            this.subTotal = data.subTotal
            this.grandTotal = data.grandTotal
            this.bogoDiscount = data.bogoDiscount
            this.cartDiscount = data.cartDiscount
            if (data.billingInfo) {
                this.billingInfo = new BillingInfo(data.billingInfo)
            }
            this.deliveryFee = data.deliveryFee
            if (data.payment) {
                this.payment = new Payment(data.payment)
            }
        }
    }
}